<template>
  <v-dialog v-model="localValue" max-width="400" lazy>
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.trainings.delWeeklyTraining') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text py-0>
        <v-layout row wrap>
          <v-flex xs12 px-2>
            <v-radio-group v-model="delType">
              <v-radio
                :label="$t('titles.trainings.current')"
                color="primary"
                value="current"
              />
              <v-radio
                :label="$t('titles.trainings.currentAndNext')"
                color="primary"
                value="currentAndNext"
              />
              <v-radio
                :label="$t('titles.trainings.all')"
                color="primary"
                value="all"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="close" />
        <meta-button
          type="delete"
          :loading="loading"
          @click="$emit('submit', delType)"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogDeleteWeeklyTraining',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      delType: 'current',
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    localValue(val) {
      if (!val) this.delType = 'current'
    },
  },
  methods: {
    close() {
      this.delType = 'current'
      this.localValue = false
    },
  },
}
</script>
